import React from "react";
import Pagenotfoundimage from "../assets/images/page_under_construction.png"
import { Link } from "react-router-dom";
function PageunderConstruction(){
    return(
        <section className="pt-40 pb-40 page_notfound">
             <div className="container">
                  <div className="row" style={{justifyContent:'center'}}>
                      <div className="col-lg-6 col-md-8 col-sm-12">
                          <div className="inner-box">
                             <img src={Pagenotfoundimage} alt="img"/>  
                             <h4 style={{color:'#374706'}}>The Page Under Construction </h4> 
                         
                             <div className="btn_box">
                                  <Link to='/'> Go to home page</Link>
                             </div>
                          </div>
                      </div>
                  </div>
             </div>
        </section>
    )
}

export default PageunderConstruction;